import { useSelector } from 'react-redux';
import { RootState } from '@msc-b2c/shared-utils';
import VoyagerClubMembershipDetails from './VoyagerClubMembershipDetails';
import { VoyagerClubMembershipDetailsProps } from '@msc-b2c/interfaces/types';

export function VoyagerClubMembershipDetailsWrapper(
  props: Readonly<VoyagerClubMembershipDetailsProps>
) {
  // Get user data from Redux
  const membershipData = useSelector((state: RootState) => state.myCruise.membershipData);

  const membership = membershipData?.memberships?.[0];

  // Merge Redux data with AEM props
  return (
    membership && (
      <VoyagerClubMembershipDetails
        {...props}
        membershipLevel={membership?.cardType}
        memberName={membership?.customer?.name || ''}
        memberSurname={membership?.customer?.surname || ''}
        cardNumber={membership?.number || ''}
        expirationDate={membership?.expiryDateTime || ''}
        currentPoints={membership?.points?.current || 0}
        pointsToNextLevel={membership?.points?.nextLevel || 0}
      />
    )
  );
}

VoyagerClubMembershipDetailsWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubmembershipcard';

export default VoyagerClubMembershipDetailsWrapper;
